/* eslint-disable global-require */

import angular from 'angular';

import DatasheetController from './datasheet-form.controller';

export default angular.module('autoboard.formDatasheet', [])
  .directive('formDatasheet', () => {
    'ngInject';

    return {
      controller: DatasheetController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '=',
      },
      templateUrl: require('./datasheet-form.template.html'),
    };
  })
  .name;
